import type { ShareButtonProps, SocialShareType } from "@product/scmp-sdk";
import { ShareButton } from "@product/scmp-sdk";
import { bindMenu, bindTrigger, usePopupState } from "material-ui-popup-state/hooks";
import React from "react";
import type { FunctionComponent } from "react";

import { Menu } from "~/components/common/menu";
import { MenuItemStyled } from "~/components/common/menu/styles";
import { useArrowModifiers } from "~/components/common/popper/hooks";
import { Fade } from "~/components/transition/fade";

import { ShareContainer, StyledArrowUp } from "./styles";
import { ToolbarButton } from "./toolbar-button";

export type Props = Pick<ShareButtonProps, "relativeUrl" | "shortUrl" | "title" | "utm">;

export const ToolbarButtonShare: FunctionComponent<Props> = ({
  relativeUrl,
  shortUrl,
  title,
  utm,
}) => {
  const popupState = usePopupState({
    popupId: "gallery-share-menu",
    variant: "popper",
  });
  const { arrowModifier, captureArrowElementReference } = useArrowModifiers();

  const renderMenuItems = () => {
    const socialShareTypes: SocialShareType[] = ["facebook", "twitter", "email"];
    return socialShareTypes.map(type => (
      <MenuItemStyled key={type}>
        <ShareButton
          relativeUrl={relativeUrl}
          shortUrl={shortUrl}
          title={title}
          type={type}
          utm={utm}
          hideIcon
          showLabel
        />
      </MenuItemStyled>
    ));
  };

  return (
    <>
      <ShareContainer onClick={() => popupState.isOpen && popupState.close()}>
        <span {...bindTrigger(popupState)}>
          <ToolbarButton icon="share" title="Share" />
        </span>

        <Fade inProperty={popupState.isOpen} timeout={100}>
          <Menu
            {...bindMenu(popupState)}
            slotProps={{
              root: {
                disablePortal: true,
                keepMounted: true,
                modifiers: [arrowModifier],
              },
            }}
          >
            <>
              <StyledArrowUp ref={captureArrowElementReference} />
              {renderMenuItems()}
            </>
          </Menu>
        </Fade>
      </ShareContainer>
    </>
  );
};

ToolbarButtonShare.displayName = "ToolbarButtonShare";
